import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Loader2 } from 'lucide-react';
import AdminDashboard from './AdminDashboardNew';
import ClientDashboard from './ClientDashboard';

const DashboardRouter = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <main className="page-content">
        <div className="flex items-center justify-center" style={{ minHeight: 'calc(100vh - 72px)' }}>
          <Loader2 size={32} className="animate-spin" style={{ color: 'var(--teal)' }} />
        </div>
      </main>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  // Admin, Manager, and Sales Rep all use the CRM dashboard
  // ClientDashboard is only for customers (role: client)
  const crmRoles = ['admin', 'sales_rep', 'manager'];
  return crmRoles.includes(user.role) ? <AdminDashboard /> : <ClientDashboard />;
};

export default DashboardRouter;
